import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { UpdateProductTabProps } from '../../../interfaces/Product/UpdateProductTab';
import {
  getProductOptions,
  updateProductOptionMedia,
} from '../../../api/ProductOption';
import { ProductOption } from '../../../interfaces/ProductOption/ProductOption';
import { getMediaPrefix } from '../../../api/Settings';
import { MediaOptions } from '../../../interfaces/MediaOptions';
import { Waiting } from '../../../components/Waiting/Waiting';
import { ImageInput } from '../../../components/ImageInput/ImageInput';

export const UpdateProductOptionsMedia = (props: UpdateProductTabProps) => {
  const [loadingSettings, setLoadingSettings] = useState(false);
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [updating, setUpdating] = useState(false);

  const [options, setOptions] = useState<ProductOption[]>([]);
  const [urlPrefix, setUrlPrefix] = useState('');

  const refreshOptions = () => {
    setLoadingOptions(true);
    getProductOptions(props.productID)
      .then((res) => setOptions(res.options))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoadingOptions(false));
  };

  useEffect(() => {
    refreshOptions();

    setLoadingSettings(true);
    getMediaPrefix()
      .then((prefix) => setUrlPrefix(prefix))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoadingSettings(false));
  }, []);

  const handleUpdate = (position: number, media: MediaOptions) => {
    setUpdating(true);
    updateProductOptionMedia(props.productID, position, media)
      .then(() => {
        toast.success('Medya başarıyla güncellendi');
        refreshOptions();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setUpdating(false));
  };

  const loading = loadingOptions || loadingSettings || updating;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: 1.5,
        gap: 1.5,
      }}
    >
      <Waiting open={loading} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 1.5,
        }}
      >
        {!loadingOptions && !options.length && (
          <Typography>Bu ürün için varyant mevcut değil</Typography>
        )}

        {options.map((option, i) => (
          <ImageInput
            key={i}
            title={option.kvps.map((kvp) => kvp.value).join(' / ')}
            existingImage={
              option.imagePath
                ? urlPrefix + (option.imagePath ?? '')
                : undefined
            }
            enableEnhancement
            onUpload={(file) => handleUpdate(option.position, { image: file })}
            onDelete={() => handleUpdate(option.position, { eraseImage: true })}
          />
        ))}
      </Box>
    </Box>
  );
};
